import {fetchData, getUrlParameter, setSessionCookie, setUrlParameter} from "./helpers";
import {setSelectOptions} from "./select";

export function initSearch() {

    const body = jQuery('body');
    const searchByCarBtn = jQuery('#continue-by-car');
    const carManufacturerInput = jQuery('#by-car-manufacturer');
    const carYearInput = jQuery('#by-car-year');
    const carModelInput = jQuery('#by-car-model');
    const carEngineInput = jQuery('#by-car-engine');

    let carSearch = getUrlParameter('car_search');
    if (carSearch) {
        carSearch = decodeArray(carSearch);
    }

    const carPlate = getUrlParameter('car_plate');
    const searchType = getUrlParameter('search_type');

    if (carManufacturerInput.length) {
        jQuery('.by-car').on('click', () => {
            searchCarGet('manufacturer', carSearch && carSearch['make'] ? carSearch['make'] : null);
        });
        if (jQuery('.by-car.active').length > 0) {
            searchCarGet('manufacturer', carSearch &&  carSearch['make'] ? carSearch['make'] : null);
        }
    }

    if (carSearch) {
        searchDimensionsGet();
    }

    if (carPlate && searchType === 'plate') {
        searchPlateGet(carPlate);
    }

    jQuery('.product-filtering .buttons button').on('click', function(e) {
        e.preventDefault();
        const id = jQuery(this).attr('data-id');
        if (id) {
            jQuery('.form-container').css('display', 'none');
            jQuery(`#${id}`).css('display', 'block');
            jQuery('.product-filtering button').removeClass('active');
            jQuery(this).addClass('active');

            if (id === 'by-car') {
                toggleSearchSteps(1);
            }
        }
    });

    carManufacturerInput.on('change', () => {
        let make = carManufacturerInput.attr('data-value') || carManufacturerInput.val();
        if (make) {
            toggleSearchSteps(2);
            searchCarGet('year', (carSearch && carSearch['year'] ? carSearch['year'] : null), {
                make: make
            });
        }
        resetCarSearch();
    });

    carYearInput.on('change', () => {
        let make = carManufacturerInput.attr('data-value') || carManufacturerInput.val();
        let year = carYearInput.attr('data-value') || carYearInput.val();
        if (make && year) {
            toggleSearchSteps(3);
            searchCarGet('model', (carSearch && carSearch['model'] ? carSearch['model'] : null), {
                make: make,
                year: year
            });
        }
        resetCarSearch();
    });

    carModelInput.on('change', () => {
        let model = carModelInput.attr('data-value') || carModelInput.val();
        if (model) {
            let make = carManufacturerInput.attr('data-value') || carManufacturerInput.val();
            let year = carYearInput.attr('data-value') ||  carYearInput.val();
            toggleSearchSteps(4);
            searchCarGet('engine', (carSearch && carSearch['engine'] ? carSearch['engine'] : null), {
                make: make,
                model: model,
                year: year
            }, () => searchDimensionsGet());
        }
        resetCarSearch();
    });

    carEngineInput.on('change', () => {
        searchByCarBtn.css('display', carEngineInput.val() ? 'block' : 'none');
    });

    jQuery('#search-by-plate').on('click', (e)=> {
        e.preventDefault();
        const plate = jQuery('#car_plate').val();
        searchPlateGet(plate, true);
        setSessionCookie('number_plate', plate);
    });

    function searchPlateGet(plate, isUserInteraction = false) {
        const carPlateSelect = jQuery('#by-car-plate-select-dimensions');
        const wrapper = carPlateSelect.find('.by-car-select-dimensions-inner');
        const byCarPlate = jQuery('#by-car-plate');
        const byCarPlateAuto = jQuery('#by-car-plate-auto');

        byCarPlate.addClass('loading');
        byCarPlate.find('.car-plate-col').css('display', 'none');
        carPlateSelect.css('display', 'block');
        fetchData('search_by_plate', {
            plate: plate,
            referer: window.location.pathname,
            search: window.location.search,
        }, (result) => {

            byCarPlate.removeClass('loading');
            if (result.url && isUserInteraction && window.location.href !== result.url) {
                window.location.href = result.url;
            }

            buildCarResults(byCarPlateAuto, result.name);

            if (result.data) {
                buildCarResultLinks(wrapper, result, 'plate');
            } else {
                wrapper.html('');
            }
        });
    }

    searchByCarBtn.on('click', function (e) {
        e.preventDefault();

        const make = carManufacturerInput.attr('data-value') || carManufacturerInput.val();
        const model = carModelInput.attr('data-value') || carModelInput.val();
        const year = carYearInput.attr('data-value') || carYearInput.val();
        const engine = carEngineInput.attr('data-value') || carEngineInput.val();

        setUrlParameter('type', jQuery('#by-season').val() || jQuery('#type').val() || '');
        setUrlParameter('manufacturer', jQuery('#by-car-tyre-manufacturer').val() || '');
        setUrlParameter('car_search', encodeArray({
            make: make,
            model: model,
            engine: engine,
            year: year,
            name: `${carManufacturerInput.val()} ${carModelInput.val()} ${carYearInput.val()} ${carEngineInput.val()}`
        }));

        jQuery(this).addClass('btn-loading');
        searchDimensionsGet(true);
    });

    function searchCarGet(step = 'manufacturer', selectedOption, data = null, callback = () => {} ) {
        const element = jQuery(`#by-car-${step}`);
        const parent = element.parent();
        element.val('');
        element.removeAttr('data-value');
        parent.parent().parent().find('label').addClass('loading');
        parent.find('select').html('');

        fetchData(`search_by_list_${step}s`, data, (result) => {
            parent.parent().parent().find('label').removeClass('loading');
            setSelectOptions(element, result);
            if ( !carSearch && selectedOption) {
                element.attr('data-value', selectedOption);
                element.val(parent.find(`[data-slug="${selectedOption}"]`).text()).trigger('change');
                callback();
            }
        });
    }

    function searchDimensionsGet(isUserInteraction = false) {
        jQuery('#by-car').addClass('loading');
        searchByCarBtn.removeClass('btn-loading').css('display', 'none');
        jQuery('#by-car .step-fields').css('display', 'none');
        jQuery('#by-car-select-dimensions').css('display', 'block');

        const carSearchData = decodeArray(getUrlParameter('car_search'));

        buildCarResults(jQuery('#by-car-auto'), carSearchData['name']);
        fetchData('search_by_list_dimensions', {
            make: carSearchData['make'],
            model: carSearchData['model'],
            year: carSearchData['year'],
            engine: carSearchData['engine'],
            season: getUrlParameter('type'),
            manufacturer: getUrlParameter('manufacturer'),
            productType: getUrlParameter('product_type'),
            referer: window.location.pathname,
            search: window.location.search,
        }, (result) => {

            if (result.url && isUserInteraction && window.location.href !== result.url) {
                window.location.href = result.url;
            }

            const wrapper = jQuery("#by-car-select-dimensions .by-car-select-dimensions-inner");
            buildCarResultLinks(wrapper, result, result.display);

            jQuery('#by-car').removeClass("loading");
        });
    }

    function buildCarResults(elm, name) {
        elm.html(`<span>${name}</span><span class="remove">×</span>`).css('display', 'block');
    }

    function buildCarResultLinks(elm, result, display = '', append = false) {

        const data = result.data;
        let html = '';
        let searchParams = new URLSearchParams(window.location.search);
        if (display === 'dimensions') {
            html += `<div class="col-title">Dimensjon, “</div>`;
            html += result.data_html;
        } else {
            html += `<div class="col-group">`;
            for (const number in data) {
                let links = '';

                Object.entries(data[number]).forEach(([key, entry]) => {
                    const nextKey = Number(key) + 1;
                    const prevKey = Number(key) - 1;
                    const active = getUrlParameter('tire') === `${entry[0]}_${entry[2]}` ? 'active ' : '';

                    if (entry[2] === 'front' && data[number][nextKey] && data[number][nextKey][2] === 'rear') {
                        links += '<div class="values-group">';
                    }

                    links += `<a href="${entry[1]}" class="${active}wheel-${entry[2]}">${entry[0]}</a>`;

                    if (entry[2] === 'rear' && data[number][prevKey] && data[number][prevKey][2] === 'front') {
                        links += '</div>';
                    }
                });

                if (display === 'dimensions') {
                    const product_type = searchParams.get('product_type');
                    const rimsize = searchParams.get('car_search_dimensjon');
                    if (searchParams.get('car_search_step') === '2') {
                        if (rimsize === number) {
                            for (const number in data) {
                                const url = new URL(result.urls[number]);
                                url.searchParams.set('car_search_dimensjon', number);
                                url.searchParams.set('car_search_step', '2');
                                html += `<div class="col"><a class="key ${rimsize === number ? 'active' : ''}" style="min-width: 50px;text-align: center;" href="${url.toString()}">${number}</a></div>`;
                            }

                            if (product_type === 'dekk') {
                                html += `</div>`;
                                html += `<div class="row gap-1 links-no-margin">`;
                                html += `${links}`;
                            }
                        }
                    } else {
                        const url = new URL(result.urls[number]);
                        url.searchParams.set('car_search_dimensjon', number);
                        url.searchParams.set('car_search_step', '2');
                        html += `<div class="col"><a class="key" style="min-width: 50px;text-align: center;" href="${url.toString()}">${number}</a></div>`;
                    }
                } else {
                    html += `<div class="col"><span class="key">${number}</span><div class="values">${links}</div></div>`;
                }
            }
            html += `</div>`;
        }

        if (append) {
            elm.append(html);
        } else {
            elm.html(html);
        }
    }

    function toggleSearchSteps(currentStep, totalSteps = 4) {
        for (let i = totalSteps; i !== 1; i--) {
            if (i > currentStep) {
                jQuery(`.by-car-step-${i}`).css('display', 'none');
            }
        }
        jQuery(`.by-car-step-${currentStep}`).css('display', 'block');
    }

    body.on('click', '#by-car-auto .remove', () => {
        toggleSearchSteps(1);
        resetCarSearch();

        const restoreParams = [];

        if (getUrlParameter('selected_felger')) {
            restoreParams['selected_felger'] = getUrlParameter('selected_felger');
        }

        if (getUrlParameter('selected_dekk')) {
            restoreParams['selected_dekk'] = getUrlParameter('selected_dekk');
        }

        window.history.replaceState({}, '', window.location.pathname);

        if (restoreParams) {
            for (const key in restoreParams) {
                //setUrlParameter(key, restoreParams[key]);
            }
            location.reload();
        }
    });

    body.on('click', '#by-car-plate-auto .remove', () => {
        jQuery('#by-car-plate .car-plate-col').css('display', '');
        jQuery('#by-car-plate .car-plate-additional, #by-car-plate-select-dimensions, #by-car-plate-auto').css('display', 'none');
    });

    function resetCarSearch() {
        jQuery('#by-car .step-fields').css('display', '');
        jQuery('#by-car-auto, #by-car-select-dimensions').css('display', 'none');
        jQuery('.car-search-additional').css('display', 'none');
        searchByCarBtn.css('display', 'none');
    }

    jQuery('.filter-list input, .filter-list select').on('change', () => {
        jQuery('.filter-list input[data-value]').each( function ()  {
            const input = jQuery(this);
            input.parent().css('--temp-value', `"${input.val()}"`);
            input.parent().addClass('hide-value');
        });
        setTimeout(() => {
            jQuery('.filter-list input[data-value]').each( function ()  {
                const input = jQuery(this);
                input.val(input.attr('data-value'));
            });
            jQuery('form#by-dimensions').submit();
        }, 300);
    });

    jQuery('[data-search-filter]').on('change', function()  {
        let name = jQuery(this).attr('name');
        if (!name) {
            name = jQuery(this).parent().find('input').attr('name');
        }
        if (name) {
            setUrlParameter(name, jQuery(this).val());
            location.reload();
        }
    });

    jQuery('.car-plate-additional [name="type"], #by-car [name="type"]').on('change', function()  {
        setUrlParameter('type', jQuery(this).val());
        location.reload();
    });

    jQuery('[name="manufacturer"], [name="pa_rim_produsent"]').on('change', function() {
        setUrlParameter('manufacturer', jQuery(this).val());
        location.reload();
    });

    jQuery('.search-container .input').on('input', function() {
        fetchData('ajax_search', {
            s: jQuery(this).val(),
            referer: window.location.pathname,
        }, (result) => {
            if (result.html) {
                jQuery('.search-container .search-results').html(result.html);
            }
        });
    });

    function encodeArray(arr) {
        return btoa(unescape(encodeURIComponent(JSON.stringify(arr))))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    function decodeArray(str) {
        return JSON.parse(
            decodeURIComponent(
                escape(atob(str.replace(/-/g, '+').replace(/_/g, '/')))
            )
        );
    }
}